'use strict';

namespace Core {

    class FlightExtraTitles {
        public Bag: () => string;
        public Bags: () => string;
        public Extra: () => string;
        public Extras: () => string;
        public Seat: () => string;
        public Seats: () => string;
    }

    class FlightExtrasSummary {

        private flightStrings: FlightExtraTitles;
        private optionCounts: any;

        public flightExtrasDescription: string = '';

        constructor(
            private $scope: ng.IScope,
            private resourceService: Core.ResourceService
        ) {

            this.flightStrings = {
                Bag: resourceService.getDeferred('BREAKDOWNBAG'),
                Bags: resourceService.getDeferred('BREAKDOWNBAGS'),
                Extra: resourceService.getDeferred('BREAKDOWNFLIGHTEXTRA'),
                Extras: resourceService.getDeferred('BREAKDOWNFLIGHTEXTRAS'),
                Seat: resourceService.getDeferred('BREAKDOWNSEAT'),
                Seats: resourceService.getDeferred('BREAKDOWNSEATS')
            };

            $scope.$watch('fes.optionCounts', (v) => {
                if (v) {
                    this.updateFlightExtrasDescription();
                }
            });
        }

        private updateFlightExtrasDescription(): void {

            //we want to build a description of the extras included with our flight eg (+ bags, seats)
            let labels: string[] = [];

            if (this.optionCounts.HoldBags > 0) {
                let bagslabel = this.optionCounts.HoldBags === 1 ? this.flightStrings.Bag() : this.flightStrings.Bags();
                labels.push(`${bagslabel}`);
            }

            if (this.optionCounts.Seats > 0) {
                labels.push(this.optionCounts.Seats === 1 ? this.flightStrings.Seat() : this.flightStrings.Seats());
            }

            if (labels.length > 0) {
                this.flightExtrasDescription =
                    String.format(
                        labels.length > 1 ? this.flightStrings.Extras() : this.flightStrings.Extra(),
                        ...labels
                    );
            } else {
                this.flightExtrasDescription = '';
            }

        }

    }

    angular
        .module('core')
        .directive('flightExtrasSummary', (): ng.IDirective => {

        return {
            scope: {},
            restrict: 'E',
            bindToController: {
                optionCounts: '='
            },
            controller: FlightExtrasSummary,
            controllerAs: 'fes',
            replace: true,
            templateUrl: 'partials/home/directivetemplate?type=FlightExtrasSummary'
        };

    });

}
